<template>
  <sc-page-base
    title="Logs de Rastreamento - Eventos">
    <sc-grid
      :rules="rules"
      :data="logs.events"
      :total="logs.events.length"
      :loading="loading"
      default-sort-column="date"
      default-sort-direction="asc"
      :default-filters="defaultFilters"
      :has-backend-pagination="true"
      :has-backend-sorting="false"
      @submit="getAllLogs"
      @click="openEvent">

      <template slot="filters" slot-scope="{ filters }">
        <sc-logs-tracking-filters :filters="filters" />
      </template>

      <template slot="filters-actions" slot-scope="{ isLoading, config }">
        <sc-button
          type="button"
          text="Exportar Excel"
          :loading="loadingExporting"
          @click="exportAllLogs(config)" />

        <sc-button
          type="submit"
          theme="primary"
          text="Buscar"
          :loading="isLoading" />
      </template>

      <template slot="table-columns" slot-scope="{ props }">
        <sc-table-column
          label="Date e hora"
          field="date"
          width="120"
          sortable>
          {{ props.row.date | date('DD/MM/YYYY HH:mm:ss') }}
        </sc-table-column>

        <sc-table-column
          label="Status"
          field="status"
          width="100"
          sortable>
          {{ props.row.status }}
        </sc-table-column>

        <sc-table-column
          label="Sub Status"
          field="substatus"
          sortable>
          {{ props.row.substatus }}
        </sc-table-column>

        <sc-table-column
          label="Mensagem"
          field="message"
          width="100"
          :centered="false">
          {{ props.row.message }}
        </sc-table-column>

        <sc-table-column
          label="Transportadora"
          field="logistic_provider"
          sortable>
          {{ getLogisticProviderName(props.row.logistic_provider_id) }}
        </sc-table-column>

        <sc-table-column
          label="Chave da Nota"
          field="invoice_key"
          width="100"
          sortable>
          {{ props.row.invoice_key }}
        </sc-table-column>

        <sc-table-column
          label="Nota fiscal"
          field="invoice_number"
          sortable>
          {{ props.row.invoice_number }}
        </sc-table-column>

        <sc-table-column
          label="Pedido"
          field="shipment_order_number"
          sortable>
          {{props.row.shipment_order_number }}
        </sc-table-column>

        <sc-table-column
          label="Cod. original"
          field="original_code"
          width="90"
          sortable>
          {{ props.row.original_code }}
        </sc-table-column>

        <sc-table-column
          label="Cod. externo"
          field="external_code"
          width="90"
          sortable>
          {{ props.row.external_code }}
        </sc-table-column>

        <sc-table-column
          label="Lote">
          <router-link
            :to="{
              name: 'logs-tracking-lote',
              params: {
                id: props.row.request_hash,
              },
            }"
            @click.native="$event.stopPropagation()">
            {{ props.row.request_hash }}
          </router-link>
        </sc-table-column>
      </template>
    </sc-grid>
  </sc-page-base>
</template>

<script>
  import {
    ScPageBase,
    ScGrid,
    ScButton,
    ScField,
    ScSelect,
    ScTableColumn,
  } from '@intelipost-js/secure-components';
  import { Moment } from '@intelipost-js/secure-providers';
  import { createNamespacedHelpers } from 'vuex';
  import ScLogsTrackingFilters from './components/sc-logs-tracking-filters/ScLogsTrackingFilters';

  const { mapState, mapActions } = createNamespacedHelpers('analytic/logsTracking');

  export default {
    name: 'page-logs-tracking',
    data() {
      return {
        rules: {
          dateRange: [{
            message: 'Informe o período de data',
            required: true,
          }],
        },
        defaultFilters: {
          typeSpecific: 'shipmentOrderNumber',
          dateRange: {
            start: Moment().subtract(1, 'days').format('YYYY-MM-DD'),
            end: Moment().format('YYYY-MM-DD'),
          },
        },
      };
    },
    computed: {
      ...mapState([
        'loading',
        'loadingExporting',
        'logs',
      ]),
    },
    methods: {
      ...mapActions([
        'getAllLogs',
        'exportAllLogs',
      ]),
      getLogisticProviderName(logisticProviderId) {
        return this.$store.getters['logisticProviders/logisticProviderName'](logisticProviderId);
      },
      openEvent(row) {
        const { request_hash, original_code } = row;

        if (request_hash) {
          this.$router.push({
            name: 'logs-tracking-detail',
            params: {
              hash: request_hash,
              original_code,
            },
          });
        }
      },
    },
    beforeMount() {
      this.$router.push('/maintenance');
      return this.$store.dispatch('logisticProviders/getLogisticProviders');
    },
    components: {
      ScPageBase,
      ScGrid,
      ScButton,
      ScField,
      ScSelect,
      ScTableColumn,
      ScLogsTrackingFilters,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/logs/pages/tracking/PageLogsTracking.vue